import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

import OfficeRoutes from './Office';
import TaxClaimantRoutes from './TaxClaimant';
import ClientRoutes from './Client';

export const ScreenFolder = 'Pages/Screens';

type Screens = 'Office' | 'TaxClaimant' | 'Client';

const ScreenRoutes: Record<Screens, RouteObject[]> = {
  Office: OfficeRoutes,
  TaxClaimant: TaxClaimantRoutes,
  Client: ClientRoutes,
};

export default ScreenRoutes;
